import { render, staticRenderFns } from "./PatientCreateRegimen.vue?vue&type=template&id=4150952a"
import script from "./PatientCreateRegimen.vue?vue&type=script&lang=js"
export * from "./PatientCreateRegimen.vue?vue&type=script&lang=js"
import style0 from "./PatientCreateRegimen.vue?vue&type=style&index=0&id=4150952a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports